export default __webpack_public_path__ + "static/media/Password-Generator14x3.81ab82a7.jpg";